
export const tycTranslate = {
    es : {
        content: [
            {
                title: `Términos y Condiciones Descuento Membresía Viva Fan`,
                tyc_title: 'true',
                content : `
                <li>Aplica únicamente para usuarios con Membresía Viva Fan activa.</li>
                <li>Promoción vigente únicamente del 29 de octubre al 29 de noviembre de 2024.</li>
                <li>Los socios con Membresía Viva Fan activa podrán obtener un descuento adicional al ya otorgado, de hasta 50% (cincuenta por ciento) (el “Descuento”). El Descuento será aplicable cuando el socio Viva Fan seleccione el Combo Light o el Combo Smart. El monto del Descuento podrá variar dependiendo de la ruta elegida. Las rutas participantes serán las que se enlistan a continuación sin importar su origen/destino:
                </li>
                <div style="padding-left:16px">
                    <li style="list-style-type: circle;">Guadalajara – Ciudad Obregón</li>
                    <li style="list-style-type: circle;">Guadalajara – Mexicalli</li>
                    <li style="list-style-type: circle;">Guadalajara – Oakland</li>
                    <li style="list-style-type: circle;">Guadalajara – Puerto Escondido</li>
                    <li style="list-style-type: circle;">Guadalajara – San Antonio</li>
                    <li style="list-style-type: circle;">Guadalajara - Torreón</li>
                    <li style="list-style-type: circle;">Monterrey - Hermosillo</li>
                    <li style="list-style-type: circle;">Monterrey - Ciudad Juarez</li>
                    <li style="list-style-type: circle;">Monterrey - Culiacan</li>
                    <li style="list-style-type: circle;">Monterrey - Mexicalli</li>
                    <li style="list-style-type: circle;">Monterrey – Oaxaca</li>
                    <li style="list-style-type: circle;">Monterrey - Morelia</li>
                    <li style="list-style-type: circle;">Monterrey – Los Mochis</li>
                    <li style="list-style-type: circle;">Monterrey - Ciudad Obregon</li>
                    <li style="list-style-type: circle;">Monterrey – Queretaro</li>
                    <li style="list-style-type: circle;">Monterrey - Bajio</li>
                    <li style="list-style-type: circle;">Monterrey – Tuxtla Gutierrez</li>
                    <li style="list-style-type: circle;">Monterrey - San Antonio</li>
                    <li style="list-style-type: circle;">Monterrey - Los Angeles</li>
                    <li style="list-style-type: circle;">Monterrey – Orlando</li>
                    <li style="list-style-type: circle;">Monterrey – Denver</li>
                    <li style="list-style-type: circle;">Monterrey - Dallas</li>
                    <li style="list-style-type: circle;">Monterrey – Houston</li>
                    <li style="list-style-type: circle;">Monterrey – Miami</li>
                    <li style="list-style-type: circle;">Tijuana – Hermosillo</li>
                    <li style="list-style-type: circle;">Santa Lucia - La Paz</li>
                </div>
                <li>Aplica para vuelos sencillos y/o redondos.</li>
                <li>La promoción está sujeta a disponibilidad de asientos.</p>
                <li>
                    Para tener acceso al Descuento, el Viva Fan deberá realizar su compra a través de nuestro Sitio en Internet, ingresando correctamente su 
                    nombre de usuario y contraseña.
                </li>
                <li>
                    Esta promoción está sujeta a los términos y condiciones generales de la Membresía Viva Fan y de Viva Aerobus, los cuales se pueden consultar en 
                    <a href="https://www.vivaaerobus.com/es-mx/legal/terminos-y-condiciones#tycVivafanadquiere" target="_blank">
                        términos y condiciones de Viva Fan
                    </a> y 
                    <a href="https://www.vivaaerobus.com/es-mx/legal/terminos-y-condiciones" target="_blank">
                        términos y condiciones de Viva Aerobus
                    </a>.
                </li>
               `,
                open: false,
            },
        ],
    },
    eng : {
        content: [
            {
                title: `Terms and Conditions for Viva Fan Membership Discount`,
                tyc_title: 'true',
                content : `
                <li>Applies only to users with an active Viva Fan Membership.</li>
                <li>Promotion valid only from October 29 to November 29, 2024.</li>
                <li>
                    Members with an active Viva Fan Membership can receive an additional discount of up to 50% (fifty percent) (the “Discount”). 
                    The Discount will apply when the Viva Fan member selects the Combo Light or Combo Smart. The Discount amount may vary depending on the selected route. 
                    The participating routes are listed below, regardless of origin/destination:
                </li>
                <div style="padding-left:16px">
                    <li style="list-style-type: circle;">Guadalajara – Ciudad Obregón</li>
                    <li style="list-style-type: circle;">Guadalajara – Mexicalli</li>
                    <li style="list-style-type: circle;">Guadalajara – Oakland</li>
                    <li style="list-style-type: circle;">Guadalajara – Puerto Escondido</li>
                    <li style="list-style-type: circle;">Guadalajara – San Antonio</li>
                    <li style="list-style-type: circle;">Guadalajara - Torreón</li>
                    <li style="list-style-type: circle;">Monterrey - Hermosillo</li>
                    <li style="list-style-type: circle;">Monterrey - Ciudad Juarez</li>
                    <li style="list-style-type: circle;">Monterrey - Culiacan</li>
                    <li style="list-style-type: circle;">Monterrey - Mexicalli</li>
                    <li style="list-style-type: circle;">Monterrey – Oaxaca</li>
                    <li style="list-style-type: circle;">Monterrey - Morelia</li>
                    <li style="list-style-type: circle;">Monterrey – Los Mochis</li>
                    <li style="list-style-type: circle;">Monterrey - Ciudad Obregon</li>
                    <li style="list-style-type: circle;">Monterrey – Queretaro</li>
                    <li style="list-style-type: circle;">Monterrey - Bajio</li>
                    <li style="list-style-type: circle;">Monterrey – Tuxtla Gutierrez</li>
                    <li style="list-style-type: circle;">Monterrey - San Antonio</li>
                    <li style="list-style-type: circle;">Monterrey - Los Angeles</li>
                    <li style="list-style-type: circle;">Monterrey – Orlando</li>
                    <li style="list-style-type: circle;">Monterrey – Denver</li>
                    <li style="list-style-type: circle;">Monterrey - Dallas</li>
                    <li style="list-style-type: circle;">Monterrey – Houston</li>
                    <li style="list-style-type: circle;">Monterrey – Miami</li>
                    <li style="list-style-type: circle;">Tijuana – Hermosillo</li>
                    <li style="list-style-type: circle;">Santa Lucia - La Paz</li>
                </div>
                <li>Applies to one-way and/or round-trip flights.</li>
                <li>The promotion is subject to seat availability.</li>
                <li>
                    To access the Discount, Viva Fan members must make their purchase through our Website, correctly entering their username and password.
                </li>
                <li>
                    This promotion is subject to the general terms and conditions of the Viva Fan Membership and Viva Aerobus, which can be found at 
                    <a href="https://www.vivaaerobus.com/en-us/legal/terms-and-conditions#tycVivafanadquiere" target="_blank">
                        Viva Fan Terms and Conditions
                    </a> and 
                    <a href="https://www.vivaaerobus.com/en-us/legal/terms-and-conditions" target="_blank">
                        Viva Aerobus Terms and Conditions
                    </a>.
                </li>
                `
            },
            
        ],
       
    }
}